// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"22":"deviceList","285":"uploadImg","535":"login","637":"order","685":"register"}[chunkId] + "." + {"22":"67d274b6","285":"26a23183","535":"95d486fa","637":"18ac93c9","685":"8bc3409d"}[chunkId] + ".css";
};